// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_iso4217 from "../../commonapis/gen/buhta_common_v1_iso4217.js";
import * as Buhta_payrollapis__Buhta_payroll_v1alpha1_card_transfer from "./buhta_payroll_v1alpha1_card_transfer.js";
import * as Buhta_payrollapis__Buhta_payroll_v1alpha2_employee from "./buhta_payroll_v1alpha2_employee.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Google_wkt__Google_protobuf_struct from "../../third_party/google_wkt/gen/google_protobuf_struct.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib from "melange/stdlib.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_payout.ml",
      92,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Payout"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Payroll"
        ]]
    });

const Payroll = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_payout.ml",
      141,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Payout"
              ]]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_payout.ml",
      188,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Payout"
        ]]
    });

const Payout = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_payout.ml",
      233,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.payroll.v1alpha1.Payout";
}

function make(idOpt, employee, stateOpt, refnumOpt, document_date, document_numOpt, currency_codeOpt, amountOpt, descriptionOpt, destination_typeOpt, destination_txnOpt, post_time, process_time, metadata, annul_time, annul_reason_message, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const state = stateOpt !== undefined ? stateOpt : "";
  const refnum = refnumOpt !== undefined ? refnumOpt : "";
  const document_num = document_numOpt !== undefined ? document_numOpt : "";
  const currency_code = currency_codeOpt !== undefined ? currency_codeOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0);
  const amount = amountOpt !== undefined ? amountOpt : "";
  const description = descriptionOpt !== undefined ? descriptionOpt : "";
  const destination_type = destination_typeOpt !== undefined ? destination_typeOpt : "";
  const destination_txn = destination_txnOpt !== undefined ? destination_txnOpt : "not_set";
  return {
          id: id,
          employee: employee,
          state: state,
          refnum: refnum,
          document_date: document_date,
          document_num: document_num,
          currency_code: currency_code,
          amount: amount,
          description: description,
          destination_type: destination_type,
          destination_txn: destination_txn,
          post_time: post_time,
          process_time: process_time,
          metadata: metadata,
          annul_time: annul_time,
          annul_reason_message: annul_reason_message
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let = Buhta_payrollapis__Buhta_payroll_v1alpha2_employee.Buhta.Payroll.V1alpha2.Employee;

const merge_employee = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "employee",
            "employee"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const merge_state = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "state",
            "state"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_refnum = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "refnum",
            "refnum"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_document_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            5,
            "document_date",
            "documentDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const merge_document_num = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            6,
            "document_num",
            "documentNum"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_currency_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            16,
            "currency_code",
            "currencyCode"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency),
          Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0)
        ]));

const merge_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            17,
            "amount",
            "amount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_description = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            18,
            "description",
            "description"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_destination_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            19,
            "destination_type",
            "destinationType"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$2 = Buhta_payrollapis__Buhta_payroll_v1alpha1_card_transfer.Buhta.Payroll.V1alpha1.CardTransfer;

const merge_oneof_destination_txn__Card_transfer = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_post_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            30,
            "post_time",
            "postTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

const $$let$4 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_process_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            31,
            "process_time",
            "processTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

const $$let$5 = Google_wkt__Google_protobuf_struct.Google.Protobuf.Struct;

const merge_metadata = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            32,
            "metadata",
            "metadata"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$5.name,
                make: $$let$5.make,
                from_proto: $$let$5.from_proto,
                from_proto_exn: $$let$5.from_proto_exn,
                to_proto: $$let$5.to_proto,
                to_proto$p: $$let$5.to_proto$p,
                merge: $$let$5.merge,
                to_json: $$let$5.to_json,
                from_json_exn: $$let$5.from_json_exn,
                from_json: $$let$5.from_json
              })
        ]));

const $$let$6 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_annul_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            33,
            "annul_time",
            "annulTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$6.name,
                make: $$let$6.make,
                from_proto: $$let$6.from_proto,
                from_proto_exn: $$let$6.from_proto_exn,
                to_proto: $$let$6.to_proto,
                to_proto$p: $$let$6.to_proto$p,
                merge: $$let$6.merge,
                to_json: $$let$6.to_json,
                from_json_exn: $$let$6.from_json_exn,
                from_json: $$let$6.from_json
              })
        ]));

const merge_annul_reason_message = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            35,
            "annul_reason_message",
            "annulReasonMessage"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

function merge(t1, t2) {
  const match = t1.destination_txn;
  const match$1 = t2.destination_txn;
  let tmp;
  let exit = 0;
  if (typeof match === "string" || !(match.NAME === "Card_transfer" && !(typeof match$1 === "string" || match$1.NAME !== "Card_transfer"))) {
    exit = 1;
  } else {
    tmp = {
      NAME: "Card_transfer",
      VAL: Curry._2(merge_oneof_destination_txn__Card_transfer, match.VAL, match$1.VAL)
    };
  }
  if (exit === 1) {
    tmp = match$1 === "not_set" ? match : match$1;
  }
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          employee: Curry._2(merge_employee, t1.employee, t2.employee),
          state: Curry._2(merge_state, t1.state, t2.state),
          refnum: Curry._2(merge_refnum, t1.refnum, t2.refnum),
          document_date: Curry._2(merge_document_date, t1.document_date, t2.document_date),
          document_num: Curry._2(merge_document_num, t1.document_num, t2.document_num),
          currency_code: Curry._2(merge_currency_code, t1.currency_code, t2.currency_code),
          amount: Curry._2(merge_amount, t1.amount, t2.amount),
          description: Curry._2(merge_description, t1.description, t2.description),
          destination_type: Curry._2(merge_destination_type, t1.destination_type, t2.destination_type),
          destination_txn: tmp,
          post_time: Curry._2(merge_post_time, t1.post_time, t2.post_time),
          process_time: Curry._2(merge_process_time, t1.process_time, t2.process_time),
          metadata: Curry._2(merge_metadata, t1.metadata, t2.metadata),
          annul_time: Curry._2(merge_annul_time, t1.annul_time, t2.annul_time),
          annul_reason_message: Curry._2(merge_annul_reason_message, t1.annul_reason_message, t2.annul_reason_message)
        };
}

function spec(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_v1alpha2_employee.Buhta.Payroll.V1alpha2.Employee;
  const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;
  const $$let$2 = Buhta_payrollapis__Buhta_payroll_v1alpha1_card_transfer.Buhta.Payroll.V1alpha1.CardTransfer;
  const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$4 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$5 = Google_wkt__Google_protobuf_struct.Google.Protobuf.Struct;
  const $$let$6 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "employee",
                        "employee"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "state",
                            "state"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "refnum",
                                "refnum"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                  [
                                    5,
                                    "document_date",
                                    "documentDate"
                                  ],
                                  Ocaml_protoc_plugin__Spec.message({
                                        name: $$let$1.name,
                                        make: $$let$1.make,
                                        from_proto: $$let$1.from_proto,
                                        from_proto_exn: $$let$1.from_proto_exn,
                                        to_proto: $$let$1.to_proto,
                                        to_proto$p: $$let$1.to_proto$p,
                                        merge: $$let$1.merge,
                                        to_json: $$let$1.to_json,
                                        from_json_exn: $$let$1.from_json_exn,
                                        from_json: $$let$1.from_json
                                      })
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        6,
                                        "document_num",
                                        "documentNum"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string,
                                      ""
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            16,
                                            "currency_code",
                                            "currencyCode"
                                          ],
                                          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency),
                                          Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0)
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                              [
                                                17,
                                                "amount",
                                                "amount"
                                              ],
                                              Ocaml_protoc_plugin__Spec.string,
                                              ""
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                  [
                                                    18,
                                                    "description",
                                                    "description"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.string,
                                                  ""
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                      [
                                                        19,
                                                        "destination_type",
                                                        "destinationType"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.string,
                                                      ""
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.oneof([
                                                          {
                                                            hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                                                                  [
                                                                    20,
                                                                    "card_transfer",
                                                                    "cardTransfer"
                                                                  ],
                                                                  Ocaml_protoc_plugin__Spec.message({
                                                                        name: $$let$2.name,
                                                                        make: $$let$2.make,
                                                                        from_proto: $$let$2.from_proto,
                                                                        from_proto_exn: $$let$2.from_proto_exn,
                                                                        to_proto: $$let$2.to_proto,
                                                                        to_proto$p: $$let$2.to_proto$p,
                                                                        merge: $$let$2.merge,
                                                                        to_json: $$let$2.to_json,
                                                                        from_json_exn: $$let$2.from_json_exn,
                                                                        from_json: $$let$2.from_json
                                                                      }),
                                                                  [
                                                                    (function (v) {
                                                                        return {
                                                                                NAME: "Card_transfer",
                                                                                VAL: v
                                                                              };
                                                                      }),
                                                                    (function (param) {
                                                                        if (typeof param === "string") {
                                                                          throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                                                    MEL_EXN_ID: Stdlib.Invalid_argument,
                                                                                    _1: "Cannot destruct given oneof"
                                                                                  });
                                                                        }
                                                                        if (param.NAME === "Card_transfer") {
                                                                          return param.VAL;
                                                                        }
                                                                        throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                                                  MEL_EXN_ID: Stdlib.Invalid_argument,
                                                                                  _1: "Cannot destruct given oneof"
                                                                                });
                                                                      })
                                                                  ]
                                                                ]),
                                                            tl: /* [] */0
                                                          },
                                                          (function (param) {
                                                              if (typeof param === "string") {
                                                                return Stdlib.failwith("Impossible case");
                                                              } else {
                                                                return 0;
                                                              }
                                                            })
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                              [
                                                                30,
                                                                "post_time",
                                                                "postTime"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.message({
                                                                    name: $$let$3.name,
                                                                    make: $$let$3.make,
                                                                    from_proto: $$let$3.from_proto,
                                                                    from_proto_exn: $$let$3.from_proto_exn,
                                                                    to_proto: $$let$3.to_proto,
                                                                    to_proto$p: $$let$3.to_proto$p,
                                                                    merge: $$let$3.merge,
                                                                    to_json: $$let$3.to_json,
                                                                    from_json_exn: $$let$3.from_json_exn,
                                                                    from_json: $$let$3.from_json
                                                                  })
                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                  [
                                                                    31,
                                                                    "process_time",
                                                                    "processTime"
                                                                  ],
                                                                  Ocaml_protoc_plugin__Spec.message({
                                                                        name: $$let$4.name,
                                                                        make: $$let$4.make,
                                                                        from_proto: $$let$4.from_proto,
                                                                        from_proto_exn: $$let$4.from_proto_exn,
                                                                        to_proto: $$let$4.to_proto,
                                                                        to_proto$p: $$let$4.to_proto$p,
                                                                        merge: $$let$4.merge,
                                                                        to_json: $$let$4.to_json,
                                                                        from_json_exn: $$let$4.from_json_exn,
                                                                        from_json: $$let$4.from_json
                                                                      })
                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                      [
                                                                        32,
                                                                        "metadata",
                                                                        "metadata"
                                                                      ],
                                                                      Ocaml_protoc_plugin__Spec.message({
                                                                            name: $$let$5.name,
                                                                            make: $$let$5.make,
                                                                            from_proto: $$let$5.from_proto,
                                                                            from_proto_exn: $$let$5.from_proto_exn,
                                                                            to_proto: $$let$5.to_proto,
                                                                            to_proto$p: $$let$5.to_proto$p,
                                                                            merge: $$let$5.merge,
                                                                            to_json: $$let$5.to_json,
                                                                            from_json_exn: $$let$5.from_json_exn,
                                                                            from_json: $$let$5.from_json
                                                                          })
                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                          [
                                                                            33,
                                                                            "annul_time",
                                                                            "annulTime"
                                                                          ],
                                                                          Ocaml_protoc_plugin__Spec.message({
                                                                                name: $$let$6.name,
                                                                                make: $$let$6.make,
                                                                                from_proto: $$let$6.from_proto,
                                                                                from_proto_exn: $$let$6.from_proto_exn,
                                                                                to_proto: $$let$6.to_proto,
                                                                                to_proto$p: $$let$6.to_proto$p,
                                                                                merge: $$let$6.merge,
                                                                                to_json: $$let$6.to_json,
                                                                                from_json_exn: $$let$6.from_json_exn,
                                                                                from_json: $$let$6.from_json
                                                                              })
                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                              [
                                                                                35,
                                                                                "annul_reason_message",
                                                                                "annulReasonMessage"
                                                                              ],
                                                                              Ocaml_protoc_plugin__Spec.string
                                                                            ]), Ocaml_protoc_plugin__Spec.nil))))))))))))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry.app(serialize, [
        writer,
        param.id,
        param.employee,
        param.state,
        param.refnum,
        param.document_date,
        param.document_num,
        param.currency_code,
        param.amount,
        param.description,
        param.destination_type,
        param.destination_txn,
        param.post_time,
        param.process_time,
        param.metadata,
        param.annul_time,
        param.annul_reason_message
      ]);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, employee, state, refnum, document_date, document_num, currency_code, amount, description, destination_type, destination_txn, post_time, process_time, metadata, annul_time, annul_reason_message) {
  return {
          id: id,
          employee: employee,
          state: state,
          refnum: refnum,
          document_date: document_date,
          document_num: document_num,
          currency_code: currency_code,
          amount: amount,
          description: description,
          destination_type: destination_type,
          destination_txn: destination_txn,
          post_time: post_time,
          process_time: process_time,
          metadata: metadata,
          annul_time: annul_time,
          annul_reason_message: annul_reason_message
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1alpha1.Payout", spec(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.id,
                param.employee,
                param.state,
                param.refnum,
                param.document_date,
                param.document_num,
                param.currency_code,
                param.amount,
                param.description,
                param.destination_type,
                param.destination_txn,
                param.post_time,
                param.process_time,
                param.metadata,
                param.annul_time,
                param.annul_reason_message
              ]);
  };
}

function constructor$1(id, employee, state, refnum, document_date, document_num, currency_code, amount, description, destination_type, destination_txn, post_time, process_time, metadata, annul_time, annul_reason_message) {
  return {
          id: id,
          employee: employee,
          state: state,
          refnum: refnum,
          document_date: document_date,
          document_num: document_num,
          currency_code: currency_code,
          amount: amount,
          description: description,
          destination_type: destination_type,
          destination_txn: destination_txn,
          post_time: post_time,
          process_time: process_time,
          metadata: metadata,
          annul_time: annul_time,
          annul_reason_message: annul_reason_message
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1alpha1.Payout", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Payout, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Payout"
        ]]
    }, V1alpha1, {
      Payout: Payout
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Payout"
              ]]
          },
          "V1alpha1"
        ]]
    }, Payroll, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Payout"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Payroll"
        ]]
    }, Buhta, {
      Payroll: Payroll
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
